import { render, staticRenderFns } from "./LiveAnswer.vue?vue&type=template&id=0d8598e2&"
import script from "./LiveAnswer.vue?vue&type=script&lang=js&"
export * from "./LiveAnswer.vue?vue&type=script&lang=js&"
import style0 from "./LiveAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports